/**
 * Theme system entry point
 * Combines all theme tokens into cohesive light and dark themes
 */

import { lightColors, darkColors, type ColorPalette } from './colors';
import { typography, type Typography } from './typography';
import { spacing, type Spacing } from './spacing';
import { effects, type Effects } from './effects';
import { breakpoints, type Breakpoints } from './breakpoints';

export interface Theme {
  colors: ColorPalette;
  typography: Typography;
  spacing: Spacing;
  borderRadius: Effects['borderRadius'];
  shadows: Effects['shadows'];
  transitions: Effects['transitions'];
  zIndex: Effects['zIndex'];
  breakpoints: Breakpoints;
}

/**
 * Base theme with shared properties
 */
const baseTheme = {
  typography,
  spacing,
  ...effects,
  breakpoints,
} as const;

/**
 * Light theme
 */
export const lightTheme: Theme = {
  ...baseTheme,
  colors: lightColors,
};

/**
 * Dark theme
 */
export const darkTheme: Theme = {
  ...baseTheme,
  colors: darkColors,
};

/**
 * Default theme (light)
 */
export const theme = lightTheme;

/**
 * Type exports for TypeScript support
 */
export type { ColorPalette, Typography, Spacing, Effects, Breakpoints };
export { lightColors, darkColors, typography, spacing, effects, breakpoints };
